var _line, _line2, _line3, _line4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _line5, _line6, _g11, _g12, _g13, _g14, _line7, _text, _text2, _line8, _line9, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSideContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1293 495.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1275.249,
    y1: 115.367,
    x2: 55.698,
    y2: 117.367,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1274.798,
    y1: 449.342,
    x2: 54.832,
    y2: 451.342,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 56.543,
    y1: 115.585,
    x2: 56.543,
    y2: 448.012,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1274.418,
    y1: 118.401,
    x2: 1274.418,
    y2: 450.768,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1155.104,
    y1: 126.275,
    x2: 1155.104,
    y2: 447.938,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1155.104,
    y1: 126.275,
    x2: 1155.104,
    y2: 132.275,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1155.104,
    y1: 144.661,
    x2: 1155.104,
    y2: 435.745,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1155.104,
    y1: 441.938,
    x2: 1155.104,
    y2: 447.938,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1034.431,
    y1: 126.163,
    x2: 1034.431,
    y2: 447.827,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1034.431,
    y1: 126.163,
    x2: 1034.431,
    y2: 132.163,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1034.431,
    y1: 144.549,
    x2: 1034.431,
    y2: 435.633,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1034.431,
    y1: 441.827,
    x2: 1034.431,
    y2: 447.827,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 913.206,
    y1: 126.715,
    x2: 913.206,
    y2: 448.379,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 913.206,
    y1: 126.715,
    x2: 913.206,
    y2: 132.715,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 913.206,
    y1: 145.102,
    x2: 913.206,
    y2: 436.185,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 913.206,
    y1: 442.379,
    x2: 913.206,
    y2: 448.379,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 788.325,
    y1: 126.498,
    x2: 788.325,
    y2: 448.162,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 788.325,
    y1: 126.498,
    x2: 788.325,
    y2: 132.498,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 788.325,
    y1: 144.885,
    x2: 788.325,
    y2: 435.969,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 788.325,
    y1: 442.162,
    x2: 788.325,
    y2: 448.162,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 667.17,
    y1: 126.131,
    x2: 667.17,
    y2: 447.795,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 667.17,
    y1: 126.131,
    x2: 667.17,
    y2: 132.131,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.17,
    y1: 144.518,
    x2: 667.17,
    y2: 435.602,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.17,
    y1: 441.795,
    x2: 667.17,
    y2: 447.795,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 546.212,
    y1: 126.586,
    x2: 546.212,
    y2: 448.25,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 546.212,
    y1: 126.586,
    x2: 546.212,
    y2: 132.586,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 546.212,
    y1: 144.973,
    x2: 546.212,
    y2: 436.056,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 546.212,
    y1: 442.25,
    x2: 546.212,
    y2: 448.25,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 425.499,
    y1: 126.385,
    x2: 425.499,
    y2: 448.049,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 425.499,
    y1: 126.385,
    x2: 425.499,
    y2: 132.385,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.499,
    y1: 144.771,
    x2: 425.499,
    y2: 435.855,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.499,
    y1: 442.049,
    x2: 425.499,
    y2: 448.049,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 297.033,
    y1: 126.079,
    x2: 297.033,
    y2: 447.743,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 297.033,
    y1: 126.079,
    x2: 297.033,
    y2: 132.079,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.033,
    y1: 144.465,
    x2: 297.033,
    y2: 435.549,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.033,
    y1: 441.743,
    x2: 297.033,
    y2: 447.743,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 179.541,
    y1: 126.318,
    x2: 179.541,
    y2: 447.981,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 179.541,
    y1: 126.318,
    x2: 179.541,
    y2: 132.318,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.541,
    y1: 144.704,
    x2: 179.541,
    y2: 435.788,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.541,
    y1: 441.981,
    x2: 179.541,
    y2: 447.981,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 65.12,
    y1: 283.628,
    x2: 1246.897,
    y2: 283.628,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 65.12,
    y1: 283.628,
    x2: 71.12,
    y2: 283.628,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.179,
    y1: 283.628,
    x2: 1234.868,
    y2: 283.628,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.06 12.06",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240.897,
    y1: 283.628,
    x2: 1246.897,
    y2: 283.628,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1275.033,
    y1: 20.453,
    x2: 1275.033,
    y2: 117.017,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 58.707,
    y1: 21.755,
    x2: 58.707,
    y2: 116.535,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 667.71,
    y1: 58.295,
    x2: 414.549,
    y2: 58.295,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 639.005,
    y1: 58.295,
    x2: 414.549,
    y2: 58.295,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "633.169 38.35 667.71 58.295 633.169 78.24 633.169 38.35"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 59.724,
    y1: 58.474,
    x2: 330.541,
    y2: 58.474,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 88.429,
    y1: 58.474,
    x2: 330.541,
    y2: 58.474,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.265 78.419 59.724 58.474 94.265 38.529 94.265 78.419"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 59.764,
    y1: 42.206,
    x2: 943.633,
    y2: 42.206,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 88.469,
    y1: 42.206,
    x2: 943.633,
    y2: 42.206,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.304 62.152 59.764 42.206 94.304 22.261 94.304 62.152"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1276.209,
    y1: 43.203,
    x2: 1032.004,
    y2: 43.203,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1247.505,
    y1: 43.203,
    x2: 1032.004,
    y2: 43.203,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1241.669 23.258 1276.209 43.203 1241.669 63.148 1241.669 23.258"
  })))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 666.932,
    y1: 47.018,
    x2: 666.932,
    y2: 117.849,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(343.135 70.653) scale(.952 1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 29,
    letterSpacing: ".055em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20ft"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(955.904 50.655) scale(.952 1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 29,
    letterSpacing: ".055em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40ft"))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1276.611,
    y1: 155.804,
    x2: 57.06,
    y2: 157.804,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1278.179,
    y1: 407.904,
    x2: 58.628,
    y2: 409.904,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(37.653 139.746) rotate(-180) scale(.952 -1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(33.878 224.765) rotate(-180) scale(.952 -1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30,
    letterSpacing: "-.018em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(16.521 349.65) scale(.952 1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(16.951 433.239) scale(.952 1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(107.557 105.994)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(227.249 105.515)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(343.529 104.846)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(459.996 105.159)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(576.931 105.042)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(693.752 105.263)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(810.156 105.585)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(931.492 105.841)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1044.097 105.652)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1165.144 105.196)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(66.824 481.067) scale(.952 1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Door"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1163.199 479.972) scale(.952 1)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Front"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSideContainer);
export default __webpack_public_path__ + "static/media/Right Side Container.44558936f12d21aee84d403d0ddbe529.svg";
export { ForwardRef as ReactComponent };